<template>
  <v-card outlined class="fill-height">
    <v-card-subtitle class="pb-1 font-weight-bold">{{ titulo }}</v-card-subtitle>
    <v-card-text v-if="linhas">
      <!-- Só interpolação de texto: os dados vêm do formulário público -->
      <div
        v-for="linha in linhas"
        :key="linha.rotulo"
        :class="{ 'linha--diferente': diferentes.includes(linha.rotulo) }"
        class="linha"
      >
        <span class="linha__rotulo">{{ linha.rotulo }}:</span> {{ linha.valor }}
      </div>
    </v-card-text>
    <v-card-text v-else>{{ textoSemDados }}</v-card-text>
  </v-card>
</template>

<script>
/** Um lado da comparação de responsável na efetivação. */
export default {
  name: "ECartaoResponsavel",
  props: {
    titulo: { type: String, required: true },
    linhas: { type: Array, default: null },
    diferentes: { type: Array, default: () => [] },
    textoSemDados: { type: String, default: "—" },
  },
};
</script>

<style scoped>
.linha {
  padding: 2px 0;
  word-break: break-word;
}

.linha__rotulo {
  color: rgba(0, 0, 0, 0.6);
}

.linha--diferente {
  font-weight: 700;
  color: #b26a00;
}
</style>
